import Vue from "vue";
import Router from "vue-router";
import routes from "vue-auto-routing";
import store from "@/store";
import { createRouterLayout } from "vue-router-layout";

Vue.use(Router);

const RouterLayout = createRouterLayout((layout) => {
  return import("@/layouts/" + layout + ".vue");
});

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: RouterLayout,
      children: routes,
    },
    // JS TODO: Implement a better Catch All strategy
    // { path: "/404", component: import("@/pages/404.vue") },
    // { path: "*", redirect: "/404" },
  ],
});

router.beforeEach((to, from, next) => {
  switch (to.path) {
    case "/system": {
      return next({ path: "/system/overview" });
    }
    case "/customer": {
      return next({ path: "/customer/overview" });
    }

    case "/msp": {
      return next({ path: "/msp/overview" });
    }
    case "/sales": {
      return next({ path: "/sales/msps" });
    }
  }
  next();
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  let userPrefs = localStorage.getItem("user_prefs");
  userPrefs = JSON.parse(userPrefs);
  if (authorize) {
    // check if route is restricted by role
    if (authorize.length && !authorize.includes(userPrefs["role"])) {
      // role not authorised so redirect to home page
      return next({ path: "/403" });
    }
  }
  next();
});

router.beforeResolve((to, from, next) => {
  store.dispatch("pageMeta/setPageSubtitle", null);

  next();
});

export default router;
